import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
})
export class AsideComponent implements OnInit {

  @Input() messageBackground=''

  @Input() pendent: any = []

  constructor() { }

  ngOnInit(): void {
  }

}
